import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import MyTable from '../../../../utils/MyTable';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import PrintIcon from '@material-ui/icons/Print';
import DefaultScrollWithHeaderContent from "../../../../utils/DefaultScrollWithHeaderContent";

import { useDispatch, useSelector } from "react-redux";


import moment from 'moment'

//Import excel
import XLSX from 'xlsx';
import _ from 'lodash';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';
import { useMemo } from "react";
import { headerSearch, unoTheme } from "../../../../../assets/styles/unoTheme";
import { loadClientDiaryByRange, loadClientRentsBySegregation } from "../../../../../controllers/ClientController";
import allActions from "../../../../../actions";
import { applyMaskAmount, applyMaskAmountFreeDecimals, getShortMonthName, greenOrRed } from "../../../../utils/utils";
import UnoButton from "../../../../utils/UnoButton";
import { downloadBlob, s2ab } from "../../../../../controllers/ExcelController";
import { codsInnerLoad } from "../../../../utils/MyInnerLoad";
import { useImperativeHandle } from "react";
import { forwardRef } from "react";
import { TableFooter } from "@material-ui/core";
import { getRegimeLabel, parseRegimeValue, REGIME_SHEET_LABELS } from "../../../../utils/accountRegimes";

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: 'green'
    },
    red: {
        color: 'red',
    },
    headerSearch: headerSearch,
    inputSearch: {
        width: "300px",
        background: "white"
    },
    toStickyHeader: {
        display: 'flex',
        height: '100%',
    },
    tableColumn: {
        display: 'flex',
        justifyContent: "center",
        alignItems: 'center',
    },
    myTableFooter: {
        cursor: "pointer",
        borderBottom: 'unset',
        '& > *': {
            borderBottom: 'unset',
        },

        '& .totalLineInvestiments': {
            '& .MuiTableCell-root': {
                color: 'black',
                borderBottom: 'unset',
                background: unoTheme.mainGrayColor,
            },
        },

        '& .totalLinePL': {
            '& .MuiTableCell-root': {
                borderBottom: 'unset',
                color: 'white',
                background: unoTheme.mainColor,
            },
        },

        '& .disponibilityLine': {
            '& .MuiTableCell-footer': {
                color: 'black',
            },
        },

        '& .MuiTableCell-root:first-child': {
            borderTopLeftRadius: '10px',
            borderBottomLeftRadius: '10px',
        },

        '& .MuiTableCell-root:last-child': {
            borderTopRightRadius: '10px',
            borderBottomRightRadius: '10px',
        },

        '& .spanTotal': {
            //color: unoTheme.greenMoney,
            fontSize: '14px',
        }
    },
});

const ReturnsTab = forwardRef((props, ref) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const { segregationSelected } = props;
    const accountRegimeId = parseRegimeValue(segregationSelected);

    const clientOn = useSelector(state => state.clientOn)
    const [clientReturns, setClientReturns] = useState([]);
    const [lastQuota, setLastQuota] = useState(null);

    const [orderBy, setOrderBy] = useState("date_quota"); //coluna
    const [order, setOrder] = useState("desc")    // direção

    const [innerLoad, setInnerLoad] = useState({


        emptyMessage: "",
        loadMessage: "Carregando retornos diários...",
        size: "small"

    })

    async function doGetAllClientReturns(clientId, month, year, segregationCode) {

        segregationCode = parseInt(segregationCode);
        const response = segregationCode ?
            await loadClientRentsBySegregation(clientId,
                month,
                year, 1) :
            await loadClientDiaryByRange(clientId,
                month,
                year, 1); //Passando parâmetro 1 pois se quer apenas o período informado

        if (response.isSuccessful) {

            const diarys = segregationCode ?
                response.mapDiarysBySegregation[segregationCode] :
                response.arrayRents[0].diarys;

            const lastQuota = segregationCode ?
                response.lastQuotasBySegregation[segregationCode] :
                response.lastQuota;

            const clientReturns = diarys.reverse().map(item => {
                const new_pl = parseFloat(item.new_pl);
                const result_app_rescues = parseFloat(item.result_app_rescues);
                const pl_before = parseFloat(item.pl_before);

                return {
                    ...item,
                    return: new_pl - result_app_rescues - pl_before
                };
            })

            setClientReturns(clientReturns);
            setLastQuota(lastQuota);
            setInnerLoad(null)

        } else {

            setInnerLoad({
                emptyMessage: "Erro ao consultar retornos",
            })
        }

    }

    function makeReport() {
        const reportType = 'myReturns';

        dispatch(allActions.reportLoadActions.setReportLoad({
            show: true,
            reportType,
            accountRegimeId,
            regimeLabel: accountRegimeId ? getRegimeLabel(accountRegimeId) : null,
            message: 'Gerando relatório...'
        }));
    }

    function doExcel(items, month, year) {

        const regimeSuffix = accountRegimeId ? `_${REGIME_SHEET_LABELS[accountRegimeId]}` : '';
        const fileName = `Retornos_${getShortMonthName(month)}_${year}${regimeSuffix}`;

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Gerando planilha...',
        }));

        const wb = XLSX.utils.book_new();
        wb.Props = {
            Title: fileName,
            Author: "UNO",
        }

        //Nome da aba do XLSX tem limite de 31 caracteres
        const sheetName = fileName.slice(0, 31);
        wb.SheetNames.push(sheetName);

        const ws_data = [];

        ws_data.push([
            'Data',
            'PL (inicio do dia)',
            'Movimentações',
            'Qtd. Cotas (inicio do dia)',
            'Add Cotas',
            'Retorno (R$)',
            'Retorno (%)',
            'PL (fim do dia)',
            'Qtd. Cotas (fim do dia)',
            'Cota do dia',
        ])

        items.forEach(row => {

            ws_data.push([
                moment.utc(row.date_quota).format('DD/MM/YYYY'),
                applyMaskAmount(row.pl_before, true),
                applyMaskAmount(row.result_app_rescues, true),
                applyMaskAmountFreeDecimals(row.qtd_quotas - row.add_quotas, null, 10),
                applyMaskAmountFreeDecimals(row.add_quotas, null, 10),
                applyMaskAmount(row.new_pl - parseFloat(row.result_app_rescues) - row.pl_before, true),
                applyMaskAmountFreeDecimals(row.rent_day) + "%",
                applyMaskAmount(row.new_pl, true),
                applyMaskAmountFreeDecimals(row.qtd_quotas, null, 10),
                applyMaskAmountFreeDecimals(row.quota_value, null, 10),
            ])

        });

        const ws = XLSX.utils.aoa_to_sheet(ws_data);

        wb.Sheets[sheetName] = ws;
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' })

        downloadBlob(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName + '.xlsx');

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: false,
        }));
    }

    const sortedReturns = useMemo(() => {
        if (!clientReturns) return [];
        if (!orderBy) return clientReturns;

        return _.orderBy(clientReturns, [orderBy], [order]);
    }, [clientReturns, orderBy, order]);

    const SortIcon = ({ column }) => {
        const isActive = orderBy === column;

        if (!isActive) {
            return <ArrowDropDown style={{ color: "#ccc" }} />;
        }

        return order === "asc" ? (
            <ArrowDropUp style={{ color: unoTheme.mainColor }} />
        ) : (
            <ArrowDropDown style={{ color: unoTheme.mainColor }} />
        );
    };

    const handleSort = (column) => {
        if (orderBy === column) {
            setOrder(order === "asc" ? "desc" : "asc");
        } else {
            setOrderBy(column);
            setOrder("asc");
        }
    };

    useImperativeHandle(ref, () => ({
        doExcelReport() {
            doExcel(clientReturns, clientOn.client.selectedPortfolioMonth, clientOn.client.selectedPortfolioYear)
        },
        doPdfReport() {
            makeReport();
        }
    }));

    useEffect(() => {
        if (clientOn && clientOn.client && clientOn.client.id
            && clientOn.client.selectedPortfolioMonth && clientOn.client.selectedPortfolioYear && segregationSelected != null) {

            setClientReturns([]);
            setLastQuota(null)
            doGetAllClientReturns(clientOn.client.id, clientOn.client.selectedPortfolioMonth, clientOn.client.selectedPortfolioYear, segregationSelected);

        } else {
            setInnerLoad({
                emptyMessage: "Os retornos se dão a partir do lançamento de pelo menos um mês de carteira",
            })

        }


    }, [clientOn, segregationSelected]);

    return (
        <div className={classes.root}>

            {/* <UnoButton
                        style={{ marginRight: "8px" }}
                        size={'small'}
                        onClick={() => doExcel(clientReturns, clientOn.client.selectedPortfolioMonth, clientOn.client.selectedPortfolioYear)}
                        type='success'
                        startIcon={<PrintIcon />}>
                        {"Excel"}
                    </UnoButton> */}
            {/* <UnoButton
                        size={'small'}
                        className={classes.spacingLeft1}
                        onClick={() => makeReport()}
                        type='primary'
                        startIcon={<PrintIcon />}>
                        {"Gerar relatório"}
                    </UnoButton> */}
            <DefaultScrollWithHeaderContent innerLoad={innerLoad}>
                <MyTable
                    stickyHeader
                    size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell onClick={() => handleSort("date_quota")}>
                                <div className={classes.tableColumn}>
                                    Data <SortIcon column="date_quota" />
                                </div>
                            </TableCell>
                            <TableCell onClick={() => handleSort("pl_before")}>
                                <div className={classes.tableColumn}>
                                    PL <span style={{ color: unoTheme.mainColor, fontSize: '10px' }}>(Início do dia)</span> <SortIcon column="pl_before" />
                                </div>
                            </TableCell>
                            <TableCell onClick={() => handleSort("result_app_rescues")}>
                                <div className={classes.tableColumn}>
                                    Movimentações <SortIcon column="result_app_rescues" />
                                </div>
                            </TableCell>
                            <TableCell onClick={() => handleSort("return")}>
                                <div className={classes.tableColumn}>
                                    Retorno(R$) <SortIcon column="return" />
                                </div>
                            </TableCell>
                            {
                                segregationSelected ?
                                    <TableCell align="center">
                                        Cota
                                    </TableCell> : null
                            }

                            <TableCell onClick={() => handleSort("rent_day")}>
                                <div className={classes.tableColumn}>
                                    Retorno(%) <SortIcon column="rent_day" />
                                </div>

                            </TableCell>
                            <TableCell onClick={() => handleSort("new_pl")}>
                                <div className={classes.tableColumn}>
                                    PL <span style={{ color: unoTheme.mainColor, fontSize: '10px' }}>(Fim do dia)</span> <SortIcon column="new_pl" />
                                </div>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sortedReturns.map((row, index) => (
                            <TableRow key={'diarys-' + index}>
                                <TableCell align="center">{moment.utc(row.date_quota).format('DD/MM/YYYY')}</TableCell>
                                <TableCell align="center" style={{ color: unoTheme.mainColor }}>{applyMaskAmount(row.pl_before, true)}</TableCell>
                                <TableCell align="center" style={{ color: parseFloat(row.result_app_rescues) >= 0 ? unoTheme.greenMoney : unoTheme.redMoney }}>{applyMaskAmount(row.result_app_rescues, true)}</TableCell>
                                <TableCell align="center" style={{ color: greenOrRed(row.return) }}>{applyMaskAmount(row.return, true)}</TableCell>
                                {
                                    segregationSelected ?
                                        <TableCell align="center">{applyMaskAmountFreeDecimals(row.quota_value)}</TableCell>
                                        : null
                                }
                                <TableCell align="center" style={{ color: greenOrRed(row.rent_day) }}>{applyMaskAmountFreeDecimals(row.rent_day)}%</TableCell>
                                <TableCell align="center" style={{ color: unoTheme.mainColor }}>{applyMaskAmount(row.new_pl, true)}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>

                    {
                        lastQuota ?
                            <TableFooter className={classes.myTableFooter}>
                                <TableRow className='totalLineInvestiments' key={'footer-returns'}>
                                    <TableCell align="center">{moment.utc(lastQuota.date_quota).format('DD/MM/YYYY')}</TableCell>
                                    <TableCell align="center" style={{ color: unoTheme.mainColor }}>{"-"}</TableCell>
                                    <TableCell align="center" style={{ color: parseFloat(lastQuota.result_app_rescues) >= 0 ? unoTheme.greenMoney : unoTheme.redMoney }}>{applyMaskAmount(lastQuota.result_app_rescues, true)}</TableCell>
                                    <TableCell align="center" style={{ color: greenOrRed(lastQuota.return) }}>{"-"}</TableCell>
                                    {
                                        segregationSelected ?
                                            <TableCell align="center">{applyMaskAmountFreeDecimals(lastQuota.quota_value)}</TableCell>
                                            : null
                                    }
                                    <TableCell align="center" style={{ color: greenOrRed(lastQuota.rent_day) }}>{"-"}</TableCell>
                                    <TableCell align="center" style={{ color: unoTheme.mainColor }}>{applyMaskAmount(lastQuota.new_pl, true)}</TableCell>
                                </TableRow>

                            </TableFooter>
                            : null
                    }

                </MyTable>
            </DefaultScrollWithHeaderContent>
        </div >
    );
})

export default ReturnsTab;



